import { ButtonVariant } from './index';

export const getButtonVariant = (variant?: string, icon?: string): ButtonVariant => {
  if (variant === 'None') {
    return ButtonVariant.bare;
  }
  if (variant === 'Secondary') {
    return ButtonVariant.secondary;
  }
  if (variant === 'Tertiary') {
    return ButtonVariant.tertiary;
  }
  if (variant === 'Text & Icon') {
    if (icon === 'Skewer') {
      return ButtonVariant.skewer;
    }
    if (icon === 'Knife') {
      return ButtonVariant.knife;
    }
    return ButtonVariant.bare;
  }
  return ButtonVariant.primary;
};
